
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1012295801533399');
    fbq('track', 'PageView');
    

    !function (w, d, t) {
    w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
    var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
    ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};


    ttq.load('D9JIQG3C77UAKD58INV0');
    ttq.page();
    }(window, document, 'ttq');
    

    (function () {
      var UTM_KEYS = [
        'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
        'ttclid', // TikTok click ID — нужен, чтобы TikTok Ads засчитывал конверсию с рекламы
        'fbclid'  // Meta click ID — то же самое для Facebook/Instagram Ads
      ];
      var STORAGE_KEY = 'mp_utm_data';
      var EXPIRY_DAYS = 30;

      function getUtmFromUrl() {
        var params = new URLSearchParams(window.location.search);
        var data = {};
        var found = false;
        UTM_KEYS.forEach(function (key) {
          if (params.has(key)) {
            data[key] = params.get(key);
            found = true;
          }
        });
        return found ? data : null;
      }

      function saveUtm(data) {
        try {
          data.landing_page = window.location.pathname;
          data.expires_at = Date.now() + EXPIRY_DAYS * 24 * 60 * 60 * 1000;
          localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch (e) {}
      }

      function getSavedUtm() {
        try {
          var raw = localStorage.getItem(STORAGE_KEY);
          if (!raw) return null;
          var data = JSON.parse(raw);
          if (data.expires_at && Date.now() > data.expires_at) {
            localStorage.removeItem(STORAGE_KEY);
            return null;
          }
          return data;
        } catch (e) {
          return null;
        }
      }

      function reapplyUtmToUrl(data) {
        var params = new URLSearchParams(window.location.search);
        var changed = false;
        UTM_KEYS.forEach(function (key) {
          if (data[key] && !params.has(key)) {
            params.set(key, data[key]);
            changed = true;
          }
        });
        if (changed) {
          var newUrl = window.location.pathname + '?' + params.toString() + window.location.hash;
          window.history.replaceState({}, '', newUrl);
        }
      }

      function pushUtmToCartAttributes(data) {
        var attributes = {};
        UTM_KEYS.forEach(function (key) {
          if (data[key]) attributes[key] = data[key];
        });
        if (data.landing_page) attributes.landing_page = data.landing_page;
        if (Object.keys(attributes).length === 0) return;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).catch(function () {});
      }

      var urlUtm = getUtmFromUrl();

      if (urlUtm) {
        saveUtm(urlUtm);
        pushUtmToCartAttributes(urlUtm);
      } else {
        var saved = getSavedUtm();
        if (saved) {
          reapplyUtmToUrl(saved);
          pushUtmToCartAttributes(saved);
        }
      }
    })();
    